import CustomAmount, { CustomAmountProps } from './CustomAmount';

export type { CustomAmountProps };
export default CustomAmount;
